import React from 'react';

interface SentimentAnalysisIconProps {
  style?: React.CSSProperties;
}

const SentimentAnalysisIcon: React.FC<SentimentAnalysisIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Sentiment Analysis</title>
      <path d="M12.99 0L0 7.5v15L12.99 30l12.99-7.5v-15L12.99 0z" fill="#6A11EA" />
      <path d="M12.99 3.75l6.495 3.75V15l-6.495-3.75L6.495 15V7.5l6.495-3.75z" fill="#FD9D52" />
      <path d="M12.99 18.75L6.495 15v7.5l6.495 3.75 6.495-3.75V15l-6.495 3.75z" fill="#DD45D3" />
    </svg>
  );
};

export default SentimentAnalysisIcon;
